<template>
  <div class="ProgramModule-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
            <span class="svg-icon">
              <inline-svg
                :src="`/media/svg/icons/Neolex/Basic/${
                  isCreateForm ? 'plus' : 'save'
                }.svg`"
              />
            </span>
            {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
          </b-button>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container fluid class="ProgramModule-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">Thông tin mô đun</h5>
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Mã mô đun"
                            placeholder="Mã mô đun"
                            name="code"
                            data-vv-as="Mã mô đun"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.code"
                            :state="validateState('code')"
                            :invalidFeedback="errors.first('code')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-select
                            label="Trạng thái hoạt động"
                            placeholder="Chọn trạng thái hoạt động"
                            name="status"
                            :options="statuses"
                            track-by="value"
                            value-label="text"
                            :value.sync="form.status"
                            data-vv-As="Trạng thái hoạt động"
                            v-validate="'required'"
                            :required="true"
                            :state="validateState('status')"
                            :invalidFeedback="errors.first('status')"
                            @input="selected($event, 'status', statuses)"
                          ></basic-select>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Tên mô đun"
                            placeholder="Tên mô đun"
                            name="name"
                            data-vv-as="Tên mô đun"
                            :required="true"
                            v-validate="'required|max:255'"
                            :value.sync="form.name"
                            :state="validateState('name')"
                            :invalidFeedback="errors.first('name')"
                          ></basic-input>
                        </b-col>

                        <b-col>
                          <basic-input
                            label="Thời lượng (tuần)"
                            placeholder="Nhập số tuần"
                            name="totalWeek"
                            data-vv-as="Thời lượng (tuần)"
                            :required="true"
                            v-validate="
                              'required|numeric|min_value:1|max_value:52'
                            "
                            :value.sync="form.totalWeek"
                            :state="validateState('totalWeek')"
                            :invalidFeedback="errors.first('totalWeek')"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Mô tả"
                            placeholder="Mô tả"
                            name="description"
                            data-vv-as="Mô tả"
                            :required="false"
                            v-validate="'required'"
                            :value.sync="form.description"
                            :state="validateState('description')"
                            :invalidFeedback="errors.first('description')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <div class="form-group">
                            <label class="color-label">Màu</label>
                            <div class="color-picker-container">
                              <input
                                type="color"
                                name="color"
                                v-model="form.color"
                                v-validate="'required'"
                                class="w-100 rounded-pill"
                                :class="{
                                  'is-invalid': errors.has('color'),
                                  'is-valid':
                                    validateState('color') &&
                                    !errors.has('color'),
                                }"
                              />
                              <span
                                v-if="errors.has('color')"
                                class="invalid-feedback"
                                >{{ errors.first('color') }}</span
                              >
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        :src="`/media/svg/icons/Neolex/Basic/${
                          isCreateForm ? 'plus' : 'save'
                        }.svg`"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      statuses: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
      ],
      form: {},
      file: null,
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadProgramModuleData();
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] =
        optionsArr.find((el) => el.value === value) || null;
      const selectedValue = this.form[formProperty];

      if (selectedValue || selectedValue?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
      }

      this.$nextTick(() => {
        this.$validator.validate(formProperty);
      });
    },
    resetData() {
      this.form.code = null;
      this.form.status = null;
      this.form.name = null;
      this.form.totalWeek = null;
      this.form.description = null;
      this.form.color = null;
      this.$validator.reset();
    },
    handleChangeSelect(value, formProperty) {
      console.log('isShowError', this.isShowError);
      var newOptions = value ? value[0] : null;
      console.log(newOptions);

      switch (formProperty) {
        default:
          break;
      }
    },

    async initDataInSelect() {
      try {
        this.loading = true;
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'program_module_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      this.form.code && payload.append('code', this.form.code);
      this.form.status &&
        payload.append(
          'status',
          typeof this.form.status === 'object'
            ? this.form.status.value
            : this.form.status,
        );
      this.form.name && payload.append('name', this.form.name);
      this.form.totalWeek && payload.append('totalWeek', this.form.totalWeek);
      this.form.description &&
        payload.append('description', this.form.description);
      this.form.color && payload.append('color', this.form.color);

      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo Mô đun mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin Mô đun này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`ProgramModule`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Mô đun mới đã được tạo!',
        });
        this.$router.push({ name: 'program_module_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại tên mô đun không được trùng',
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`ProgramModule/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Mô đun đã được cập nhật!',
        });
        this.$router.push({ name: 'program_module_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadProgramModuleData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramModule/${id}`);
        this.form = data;
        this.form.status =
          this.statuses.find((item) => item.value === data.status) || null;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
